import { createContext, useContext } from 'react'
import type { PropsWithChildren } from 'react'
import { useRiveFile, type RiveFile } from '@rive-app/react-canvas'
import loaderUrl from '/static/gg_loader.riv?no-inline'

// Preloads the shared loader .riv once for the app's lifetime. Spinners render
// from the already-loaded RiveFile, so a spinner unmounting before its own
// file fetch resolves can no longer trigger Rive's
// "Attempt to use file after calling cleanup." warning.
const RiveLoaderContext = createContext<RiveFile | null>(null)

export const RiveLoaderProvider = ({ children }: PropsWithChildren) => {
  const { riveFile, status } = useRiveFile({ src: loaderUrl })

  return (
    <RiveLoaderContext.Provider value={status === 'success' ? riveFile : null}>
      {children}
    </RiveLoaderContext.Provider>
  )
}

export const useRiveLoaderFile = () => useContext(RiveLoaderContext)
